import { __assign, __rest } from "tslib";
/** @jsx jsx */
import { jsx } from '@emotion/core';
import MenuGroup from './menu-group';
var PopupMenuGroup = function (_a) {
    var _b = _a.maxWidth, maxWidth = _b === void 0 ? 800 : _b, _c = _a.minWidth, minWidth = _c === void 0 ? 320 : _c, rest = __rest(_a, ["maxWidth", "minWidth"]);
    return (jsx(MenuGroup, __assign({ maxWidth: maxWidth, minWidth: minWidth }, rest)));
};
export default PopupMenuGroup;
//# sourceMappingURL=popup-menu-group.js.map